<template>
  <div>
    <h1 class="pb-3">Política de privacidade</h1>
    <p>
      A empresa <b>CENTRO POTIGUAR DE GEOCIÊNCIAS CPGEO LTDA</b>, pessoa
      jurídica de direito privado, devidamente inscrita no CNPJ sob o nº
      <b>09.354.170/0001-49</b>, com sede em Natal/RN(“<b>CPGeo</b>”),
      compreende o desejo dos usuários de proteger os seus dados pessoais e
      criou esta Política de Privacidade para demonstrar seu compromisso em
      proteger a sua privacidade e seus dados pessoais, nos termos da Lei n.º
      13.709/2018 - Lei Geral de Proteção de Dados (“LGPD”) - e demais
      legislações sobre o tema, bem como descrever de que forma sua privacidade
      é protegida pela <b>CPGeo</b> ao realizar o tratamento dos dados pessoais.
    </p>

    <p>
      Realizamos o tratamento dos seus dados pessoais seguindo os princípios
      determinados pela “LGPD” - especialmente o princípio da transparência -
      fornecendo as melhores ações na prestação de serviços de processamento de
      dados sísmicos terrestre e marítimo, 2D e 3D, PSTM, PSDM e CRS .
    </p>

    <p>
      A empresa <b>CPGeo</b> procura cumprir rigorosamente com todos os
      princípios da Lei 13.709/2018, zelando, sempre, pela privacidade dos
      titulares dos dados pessoais.
    </p>

    <h5><b>1. Definições</b></h5>

    <p>
      <b>Usuário:</b> todas as pessoas físicas que utilizarão ou visitarão o(s)
      Site(s) e/ou Aplicativo(s), maiores de 18 (dezoito) anos ou emancipadas e
      totalmente capazes de praticar os atos da vida civil ou os absolutamente
      ou relativamente incapazes devidamente representados ou assistidos.
    </p>

    <p>
      <b>Tratamento:</b> toda operação realizada com dados pessoais, como as que
      se referem a coleta, produção, recepção, classificação, utilização,
      acesso, reprodução, transmissão, distribuição, processamento,
      arquivamento, armazenamento, eliminação, avaliação ou controle da
      informação, modificação, comunicação, transferência, difusão ou extração.
    </p>

    <p>
      <b>Dados Pessoais:</b> significa informações relacionadas a pessoa natural
      identificada ou identificável.
    </p>

    <p>
      <b>Dados Pessoais Sensíveis:</b> dado pessoal sobre a origem racial ou
      étnica, convicção religiosa, opinião política, filiação a sindicato ou a
      organização de caráter religioso, filosófico ou político, dado referente à
      saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a
      uma pessoa natural.
      <br />
      Os Dados Pessoais podem estar em quaisquer meios - digitais ou físicos,
      tais como mídias de armazenamento, nuvem (cloud computer), inclusive
      registros eletrônicos ou computadorizados/digitalizados, bem como em
      arquivos baseados em papel. Os Dados Pessoais, no entanto, não incluem
      telefone comercial, número de celular comercial, endereço comercial,
      e-mail comercial.
    </p>

    <p>
      <b>Anonimização:</b> utilização de meios técnicos razoáveis e disponíveis
      no momento do tratamento, por meio dos quais um dado perde a possibilidade
      de associação, direta ou indiretamente, a um indivíduo.
    </p>

    <p>
      <b>Finalidade:</b> o objetivo da coleta de dados pessoais que devem ter um
      fim específico devendo o tratamento respeitar tal finalidade.
    </p>

    <p>
      <b>Necessidade:</b> limitação do tratamento ao mínimo necessário para
      realização de suas finalidades, evitando-se a coleta excessiva.
    </p>

    <p>
      <b>Bases legais:</b> fundamentação legal que autoriza o tratamento de
      dados pessoais para uma determinada finalidade por parte da empresa
      <b>CPGeo</b>.
    </p>

    <p>
      <b>Consentimento:</b> manifestação livre, informada e inequívoca pela qual
      o titular concorda com o tratamento de seus dados pessoais para uma
      finalidade determinada.
    </p>

    <p>
      Esta política se aplica, em geral, a todos os usuários e potenciais
      usuários (Visitantes) dos serviços oferecidos pela <b>CPGeo</b>, e ao
      utilizar os nossos serviços - nomeadamente - sites, formulários de
      contatos, redes sociais - e fornecer seus dados pessoais, você está ciente
      e consentindo com as disposições desta Política de Privacidade, além de
      conhecer seus direitos e como exercê-los.
    </p>

    <p>
      A qualquer tempo e sem nenhum custo, você poderá revogar seu
      consentimento, respeitando as determinações das leis correlatas quanto à
      guarda de arquivos/dados.
    </p>
    <p>
      Ao acessar e/ou utilizar o site da <b>CPGeo</b>, o usuário declara ter no
      mínimo 18 (dezoito) anos e ter capacidade plena e expressa para a
      aceitação dos termos e condições desta Política de Privacidade e do Termo
      de Consentimento para todos os fins de direito.
    </p>
    <p>
      A empresa <b>CPGeo</b> está empenhada em proteger os dados pessoais e a
      privacidade de crianças e adolescentes. A <b>CPGeo</b> <b>não</b> coleta
      intencionalmente informações de adolescentes menores de 18 (dezoito) anos,
      bem como não direciona seus serviços para os titulares previstos no artigo
      14 da Lei 13.709/2018. Caso o usuário não se enquadre na descrição acima
      e/ou não concorde, ainda que em parte, com os termos e condições contidos
      nesta Política de Privacidade, não deverá acessar e/ou utilizar as
      Soluções oferecidas pela <b>CPGeo</b>, bem como os sites e redes sociais
      por ela operados.
    </p>

    <h5><b>2. ÂMBITO</b></h5>

    <h6><b>2.1. No Escopo</b></h6>

    <p>
      Esta Política de Privacidade se aplica a todos os dados pessoais tratados
      pela CPGeo para o desenvolvimento das suas atividades, contemplando assim,
      o uso dos dados pessoais:
    </p>
    <ul>
      <li>
        dos usuários e visitantes das nossas plataformas online
        (https://www.cpgeo.com);
      </li>
      <li>
        dos usuários e visitantes da plataforma do LinkedIn
        (https://www.linkedin.com) que têm o seu perfil visitado por nós;
      </li>
      <li>
        dos funcionários ou representantes dos nossos clientes, outsourcing,
        quando executados nossas soluções presenciais ou online tais como,
        Treinamentos, Workshop;
      </li>
    </ul>

    <p>
      Os dados pessoais tratados pela empresa CPGeo são em sua maioria
      classificados como dados pessoais e seguem rigorosamente os preceitos da
      Lei Geral de Proteção de Dados Pessoais, mormente o artigo 7º•.
    </p>
    <p>
      Desta forma, caso você se enquadre em algum das categorias acima, esta
      Política de Privacidade é aplicável aos seus dados pessoais tratados pela
      CPGeo.
    </p>
    <p>
      Caso não concorde com a presente Política de Privacidade, solicitamos que
      não nos sejam enviados quaisquer dados pessoais.
    </p>

    <h6><b>2.2. Fora do Escopo</b></h6>

    <p>
      Esta Lei não se aplica ao tratamento de dados pessoais realizado por
      pessoa natural para fins exclusivamente particulares e não econômicos,
      como também para fins exclusivamente jornalísticos e artísticos,
      acadêmicos, segurança pública, defesa nacional, segurança do Estado ou
      atividades de investigação e repressões de infrações penais.
    </p>
    <p>
      Não aplica-se também a dados pessoais provenientes de fora do território
      nacional e que não sejam objeto de comunicação, uso compartilhado de dados
      com agentes de tratamento brasileiros ou objeto de transferência
      internacional de dados com outro país que não o de proveniência, desde que
      o país de proveniência proporcione grau de proteção de dados pessoais
      adequado ao previsto nesta Lei.
    </p>
    <p>
      É dispensada a exigência do consentimento do titular para os dados
      tornados manifestamente públicos pelo titular dos dados pessoais.
    </p>
    <p>
      Os dados anonimizados não são considerados dados pessoais para os fins da
      legislação de proteção de dados pessoais “LGPD”.
    </p>

    <h5><b>3. POLÍTICA</b></h5>

    <h6><b>3.1. Soluções - CPGeo</b></h6>

    <p>
      Nossas soluções são voltadas para atender nossos clientes na prestação de
      serviços, sendo eles:
    </p>
    <ul>
      <li>
        processamento de dados sísmicos terrestre e marítimo, 2D e 3D, PSTM,
        PSDM e CRS com praticamente 100% de conteúdo local.;
      </li>
    </ul>

    <h6><b>3.2. Controlador dos dados pessoais</b></h6>

    <p>Somos os controladores dos seus dados pessoais.</p>
    <p>
      O controlador é a pessoa natural ou jurídica, de direito público ou
      privado, a quem competem as decisões referentes ao tratamento de dados
      pessoais.
    </p>
    <p>
      No momento que a empresa CPGeo realiza suas atividades, especificamente as
      descritas no item 3.1 - Soluções- seremos os controladores dos dados
      pessoais, já que realizamos o tratamento de dados de acordo com os
      contratos entre as partes.
    </p>
    <p>
      Como controladores, verificamos a observância das próprias instruções
      internas e das normas sobre a matéria.
    </p>
    <p>
      O controlador que obtiver o consentimento para o tratamento dos dados
      pessoais e que necessitar comunicar e/ou compartilhar dados pessoais com
      outros controladores deverá obter consentimento específico do titular para
      este fim.
    </p>
    <p>
      É nossa responsabilidade como controladores compartilhar toda documentação
      acerca da proteção de dados pessoais, especialmente nossa Política de
      Privacidade.
    </p>
    <ul>
      <li>
        <b>Contato através do e-mail:.</b> Somos os controladores no tratamento
        dos dados pessoais. que podem ser enviados pelos titulares dos dados
        pessoais por meio do e-mail: (cpgeo@cpgeo.com).
      </li>
      <li>
        <b>Dados de Representantes Legais e Consultores.</b> Atuamos como
        controlador em relação aos dados dos representantes legais dos nossos
        Clientes, ou quando tratamos os dados pessoais dos nossos consultores
        autônomos.
      </li>
      <li>
        <b>Uso de cookies.</b> A empresa CPGeo faz uso de cookies, que são
        arquivos de texto enviados pela plataforma ao seu computador e que nele
        se armazenam, que contém informações relacionadas à navegação do site.
      </li>
    </ul>
    <p>
      Em síntese, os cookies são utilizados para aprimorar a experiência de uso.
    </p>
    <p>
      Ao acessar nosso site e consentir com o uso de cookies, você manifesta
      conhecer e aceitar a utilização de um sistema de coleta de dados de
      navegação com o uso de cookies em seu dispositivo.
    </p>
    <p>
      Você pode optar por deixar o seu computador avisá-lo sempre que um cookie
      for enviado ou pode optar por desativar todos os cookies. Você pode fazer
      isso por meio das configurações do seu navegador.
    </p>
    <p>
      Para gerenciar os cookies do seu navegador, basta fazê-lo nas
      configurações do navegador. Consulte o menu Ajuda de seu navegador para
      aprender a maneira correta de modificar seus cookies.
    </p>
    <ul>
      <li>
        <b>Serviços de análises.</b> Eventualmente podemos compartilhar dados
        agregados e/ou anonimizados sobre as suas ações no nosso site com
        provedores de serviços terceirizados de análise (ex. Google Analytics).
      </li>
    </ul>
    <p><b>Tais dados não são considerados dados pessoais.</b></p>
    <p>
      As informações armazenadas no software dos serviços terceirizados de
      análise, não são vinculadas pela empresa CPGeo, bem como não relacionamos
      aos dados pessoais identificáveis que o titular dos dados pessoais
      tenha-nos fornecido.
    </p>
    <p>
      O recurso Google Analytics pode ser desativado por meio de add-on do seu
      navegador. Informações adicionais acerca do serviço do Google Analytics,
      acesse o link: http://www.google.com/analytics/learn/privacy.html.
    </p>

    <h6><b>3.3. Quais dados pessoais tratamos</b></h6>

    <ul>
      <li>Dados pessoais e dados pessoais sensíveis</li>
    </ul>

    <p>
      Ao realizar os cadastros e/ou solicitar informações acerca das das
      Soluções oferecidas pela empresa CPGeo através do site, ou na contratação
      com nossa empresa, são solicitados dados pessoais e eventualmente dados
      pessoais sensíveis.
    </p>

    <p>
      A empresa CPGeo tem conhecimento que os dados pessoais sensíveis devem
      tratados mediante consentimento específico e destacado tendo finalidades
      específicas.
    </p>

    <ul>
      <li><b>Coleta automática</b></li>
    </ul>

    <p>
      Realizamos a coleta de informações de forma automática dos usuários e
      visitantes dos nossos sites, como número de endereços de protocolo de
      internet (IP), o tipo de navegador ou provedor de serviços de Internet, a
      URL’s de páginas de consulta, sistema operacional, data/hora, informações
      pesquisadas, preferências de local e idioma, números de identificação
      associados aos seus dispositivos e informações de configuração do sistema.
    </p>

    <p>
      A presente Política de Privacidade informa que devido o alcance das novas
      tecnologias e para execução completa e eficiente dos serviços oferecidos
      pela empresa CPGeo é adotado sistemas e aplicativos de terceiros tais como
      , WhatsApp, Telegram,Google Cloud Storage provedores de e-mail, operadoras
      telefônicas, etc... ; em razão disso, a empresa CPGeo é isenta das
      responsabilizadas por eventuais descumprimentos dos termos de uso e/ou
      regulamentos desses terceiros nem pelo tratamento de dados por estes
      realizados.
    </p>

    <h6><b>3.4. Quais as finalidades e bases legais para o tratamento</b></h6>

    <p>
      Realizamos o tratamento de dados pessoais e dados pessoais sensíveis para
      finalidades específicos, adotando as bases legais de acordo com cada
      cliente e os dados pessoais compartilhados com a empresa CPGeo.
    </p>

    <ul>
      <li>
        <b>Operador de dados pessoais.</b> Realizaremos as operações de
        tratamento de dados pessoais e dados pessoais sensíveis determinados e
        contratados pelo nosso Cliente - que é o controlador a quem competem as
        decisões em relação ao tratamento.
      </li>
      <li>
        <b>Controlador de dados pessoais.</b> Realizamos a maior parte do
        tratamento dos dados pessoais coletados para fins de procedimentos
        preliminares ou execução de contrato do qual o titular seja ou venha a
        fazer parte e a pedido deste ou tendo como base no legítimo interesse no
        caso envolvendo o tratamento de dados pessoais e por consentimento
        especifico e destacado, quando as ações dispuserem no tratamento de
        dados pessoais sensíveis, acordo com art. 7º, inciso V e IX, arts.10 e
        11 da “LGPD”.
      </li>
    </ul>
    <p>
      Ao nos contatar você consente que realizemos o tratamento dos seus dados
      pessoais para responder às suas solicitações.
    </p>

    <p>
      Ao fornecer seus dados pessoais você autoriza que a empresa CPGeo efetue
      promoções das nossas atividades, como a realização de treinamentos,
      palestra, tendo como base legal nosso legítimo interesse e de terceiros -
      como nossos clientes.
    </p>

    <p>
      É importante destacar que a empresa CPGeo jamais utilizará seus dados
      pessoais sensíveis para a realização de tais ações.
    </p>

    <p>
      A empresa CPGeo comunica que para o cumprimento de obrigação legal ou
      regulatória e/ou para o exercício regular de direitos em processo
      judicial, administrativos ou arbitral - conforme as regras do artigo 7° da
      Lei Geral de Proteção de Dados Pessoais - “LGPD” - realiza as ações de
      tratamento de dados pessoais pelo prazo necessário em cada legislação
      pertinente ao caso concreto.
    </p>

    <h6><b>3.5. As práticas de segurança que adotamos</b></h6>

    <p>
      Para mantermos suas informações pessoais seguras, a empresa CPGeo utiliza
      ferramentas físicas, eletrônicas e gerenciais orientadas para a proteção
      da sua privacidade.
    </p>

    <p>
      Aplicamos essas ferramentas levando em consideração a natureza dos dados
      pessoais coletados, o contexto e a finalidade do tratamento e os riscos
      que eventuais violações gerariam para os direitos e liberdades do titular
      dos dados coletados e tratados
    </p>

    <p>
      A empresa CPGeo compromete-se a a aplicar as medidas técnicas e
      organizativas a proteger os dados pessoais e dados pessoais sensíveis de
      acessos não autorizados e de situações de destruição, perda, alteração,
      comunicação ou difusão de tais dados
    </p>

    <p>
      Os dados pessoais e dados pessoais sensíveis armazenados são tratados com
      confidencialidade, integridade e disponibilidade; pilares indispensáveis
      da segurança da informação, e dentro dos limites legais. No entanto,
      podemos divulgar seus dados pessoais caso sejamos obrigados pela lei a
      fazê-lo
    </p>

    <p>
      A empresa CPGeo se exime da responsabilidade pela segurança por culpa
      exclusiva de terceiros, como no caso de ataque hacker ou cracker , ou
      culpa exclusiva do usuário, como no caso em que ele mesmo transfere seus
      dados a terceiros e/ou os torna públicos.
    </p>

    <p>
      A empresa CPGeo compromete-se a notificar o titular dos dados pessoais e a
      Autoridade Nacional de Proteção de Dados em caso de violação de segurança
      dos seus dados.
    </p>

    <h6><b>3.6. Com quem e para que compartilhamos os dados pessoais</b></h6>

    <p>
      Tendo em vista a preservação de sua privacidade, a empresa CPGeo não
      compartilhará seus dados pessoais com nenhum terceiro não autorizado
      previamente. Existem hipóteses que seus dados pessoais poderão ser
      compartilhados, que são:
    </p>

    <ul>
      <li>
        Determinação legal, requerimento ou ordem judicial, com autoridades
        judiciais, administrativas ou governamentais competentes;
      </li>
      <li>
        Proteção de direitos da empresa CPGeo em qualquer tipo de conflito,
        inclusive os de teor judicial.
      </li>
    </ul>

    <p>
      Podemos compartilhar seus dados pessoais com processadores e serviços
      terceirizados que contratamos ou utilizamos para fornecer os nossos
      serviços, destacando:
    </p>
    <ul>
      <li>Zoom (serviços de conferência);</li>
      <li>Linkedin (rede social de negócios);</li>
      <li>
        WhatsApp (aplicativo multiplataforma de mensagens instantâneas e
        chamadas de voz para smartphones);
      </li>
      <li>
        Instagram (Divulgação de Treinamentos, ações de Diversidade e Inclusão e
        campanhas);
      </li>
      <li>Microsoft (serviços do pacote Office);</li>
      <li>Google Cloud Storage.</li>
    </ul>

    <p>
      <b>Transferência internacional.</b> Alguns dos terceiros com quem
      compartilhamos seus dados podem ser localizados ou ou possuir instalações
      localizadas em países estrangeiros.
    </p>
    <p>
      Nessas condições, de toda forma, seus dados pessoais estarão sujeitos à
      Lei Geral de Proteção de Dados e às demais legislações brasileiras de
      proteção de dados.
    </p>
    <p>
      Nesse sentido, a empresa CPGeo se compromete a sempre adotar eficientes
      padrões de segurança cibernética e de proteção de dados, nos melhores
      esforços de garantir e cumprir as exigências legislativas.
    </p>
    <p>
      Ao concordar com essa Política de Privacidade, você concorda com esse
      compartilhamento, que se dará conforme as finalidades descritas no
      presente instrumento.
    </p>

    <h6><b>3.7. Por quanto tempo seus dados pessoais ficam armazenados</b></h6>

    <p>
      Suas informações pessoais serão armazenadas apenas pelo tempo necessário
      para os fins definidos nesta Política de Privacidade.
    </p>

    <p>
      Os dados pessoais dos usuários, visitantes, clientes e colaboradores são
      armazenados pela empresa CPGeo durante o período necessário para a
      prestação de serviços ou o cumprimento das finalidades previstas no
      presente documento, conforme o disposto no artigo 15 da Lei n.°
      13.709/2018.
    </p>

    <p>
      Os dados podem ser removidos ou anonimizados a pedido do usuário,
      excetuando os casos em que a lei oferecer outro tratamento.
    </p>

    <p>
      Ainda, os dados pessoais podem ser conservados após o término do
      tratamento nas hipóteses do artigo 16 da “LGPD":
    </p>

    <ol>
      <li>cumprimento de obrigação legal ou regulatória pelo controlador;</li>
      <li>
        estudo por órgão de pesquisa, garantida, sempre que possível a
        anonimização dos dados pessoais;
      </li>
      <li>
        transferência a terceiros, desde que respeitados os requisitos de
        tratamento de dados dispostos nesta Lei;
      </li>
      <li>
        Uso exclusivo do controlador, vedado seu acesso por terceiros, e desde
        que anonimizados os dados.
      </li>
    </ol>

    <h6><b>3.8. Seus direitos como titular de dados pessoais</b></h6>

    <p>
      Para exercer seus direitos de titular, você deve entrar em contato com a
      empresa CPGeo através dos seguintes meios disponíveis:
    </p>
    <ul>
      <li>cpgeo@cpgeo.com</li>
      <li>84 - 99121-8551</li>
    </ul>

    <p>
      Os direitos do titular dos dados pessoais estão descritos nos artigos 17 e
      18 da “LGPD” e são:
    </p>

    <ol>
      <li>a confirmação da existência de tratamento de seus dados pessoais;</li>
      <li>o acesso aos seus dados pessoais por nós tratados;</li>
      <li>
        a correção de seus dados pessoais incompletos, inexatos ou
        desatualizados;
      </li>
      <li>
        a anonimização, bloqueio ou eliminação de seus dados pessoais
        considerados desnecessários, excessivos ou tratados em desconformidade
        com o disposto na Lei Geral de Proteção de Dados;
      </li>
      <li>
        a portabilidade dos dados pessoais para outro fornecedor de serviço ou
        produto, mediante requisição expressa, de acordo com a regulamentação da
        autoridade nacional, observados os segredos comercial e industrial;
      </li>
      <li>
        a eliminação dos seus dados pessoais tratados com o seu consentimento,
        exceto nas hipóteses em que o tratamento foi realizado com amparo em
        base legal diversa do consentimento;
      </li>
      <li>
        informações a respeito de com quais entidades públicas e privadas nós
        realizamos uso compartilhado de dados;
      </li>
      <li>
        informações a respeito da possibilidade de não fornecer determinados
        consentimentos e sobre as consequências da negativa; e
      </li>
      <li>a revogação do consentimento.</li>
    </ol>

    <p>
      Conforme indicado no § 4º do artigo 18 da “LGPD”, no caso da
      impossibilidade da adoção imediata da providência a empresa CPGeo
      informará as razões que impedem a adoção imediata da providência.
    </p>

    <p>
      Ainda de acordo com o artigo 18, § 4º da LGPD, a empresa CPGeo pode
      comunicar não tratar-se do agente no tratamento daqueles dos dados
      pessoais.
    </p>

    <h5><b>4. PRINCÍPIOS</b></h5>

    <p>
      A CPGeo alinhada com sua missão constitucional, e de segurança da
      informação e demais documentos internos, considera, que a privacidade de
      seus clientes, funcionários e parceiro é um bem de valor inestimável.
    </p>

    <p>
      Para preservar esse bem, a CPGeo procura garantir todas as medidas
      necessárias e recomendadas pela LGPD e pelas boas práticas no tocante à
      privacidade de dados e a segurança da informação, baseando-se nos
      seguintes princípios:
    </p>

    <ul>
      <li>
        Princípio da Finalidade: Os dados coletados devem ter um fim específico,
        e o tratamento dos mesmos deve ater-se à tal finalidade;
      </li>
      <li>
        Princípio da Adequação: É a preservação das finalidades informadas para
        os quais os dados serão utilizados, e o efetivo tratamento dado à eles;
      </li>
      <li>
        Princípio da Necessidade: Limitação do tratamento ao mínimo necessário
        para a realização de suas finalidades, com abrangência dos dados
        pertinentes, proporcionais e não excessivos em relação às finalidades do
        tratamento de dados pessoais;
      </li>
      <li>
        Princípio do Livre Acesso: O titular dos dados pessoais deve ter
        assegurados os seus direitos de consulta gratuita e facilitada, sobre a
        totalidade de dados que estejam ou que estarão em poder de quem os trata
        ou tratará, assim como sobre a integralidade de seus dados. Todos os
        usuários da empresa CPGeo, podem obter qualquer destas informações, ou
        proceder à solicitações específicas em relação aos seus dados pessoais,
        através do Encarregado de Proteção de Dados Pessoais da empresa CPGeo,
        devidamente identificado nesta Política;
      </li>
      <li>
        Princípio da Qualidade dos Dados: Deve haver uma garantia, aos titulares
        dos dados, de que os mesmos serão tratados com exatidão, clareza,
        relevância, atualização, de acordo com a necessidade e para o
        cumprimento específico da finalidade para os quais os dados foram
        coletados;
      </li>
      <li>
        Princípio da Transparência: Todos os dados e tratamentos oferecidos aos
        seus titulares, devem ser informados de forma clara, precisa e
        transparente;
      </li>
      <li>
        Princípio da Segurança: O tratamento dos dados pessoais deve ser
        efetuado utilizando-se medidas técnicas e administrativas objetivando a
        proteção aos mesmos de acessos não autorizados, e de situações
        acidentais ou ilícitas de destruição, perda, alteração, comunicação ou
        difusão;
      </li>
      <li>
        Princípio da Prevenção: Adoção de medidas para prevenir a ocorrência de
        dados em virtude do tratamento de dados pessoais;
      </li>
      <li>
        Não discriminação: Os dados pessoais tratados pela empresa CPGeo são
        realizados tendo como finalidades não-discriminatórias, justas e
        lícitas;
      </li>
      <li>
        Princípio da Responsabilização e Prestação de Contas: O agente de
        tratamentos - a qualquer momento - deve ser capaz de demonstrar a adoção
        de medias que comprovem a observância e o cumprimento das normas de
        proteção de dados, e, inclusive, da eficácia de medidas.
      </li>
      <li>
        A empresa CPGeo procura cumprir rigorosamente com todos os princípios da
        Lei 13.709/2018, zelando, sempre, pela privacidade dos titulares dos
        dados pessoais.
      </li>
    </ul>

    <h5>
      <b
        >5. INVESTIGAÇÃO DE FRAUDE E VIOLAÇÃO (INCIDENTES) DE DADOS PESSOAIS -
        FORENSICS READINESS</b
      >
    </h5>

    <p>
      A fim de assegurar a integridade e a segurança das informações e dos dados
      pessoais , a CPGeo se compromete a realizar, periodicamente, perícias de
      prevenção, conduzidas por profissionais qualificados e independentes.
    </p>
    <p>
      Tais perícias terão como objetivo identificar vulnerabilidades, avaliar a
      eficácia das medidas de segurança implementadas e recomendar ações
      corretivas e preventivas, conforme necessário.
    </p>
    <p>
      A CPGeo deverá fornecer todos os acessos e informações necessárias para a
      realização da perícia de prevenção.
    </p>
    <p>
      Os resultados e relatórios gerados pela perícia serão considerados
      confidenciais e de propriedade exclusiva da CPGeo, podendo ser
      compartilhados com a terceiros (ANPD e titular dos dados pessoais e/ou nos
      casos relacionados à procedimentos de auditoria)apenas para fins de
      implementação das recomendações
    </p>
    <p>
      As perícias de prevenção serão realizadas em intervalos não superiores a
      06 (seis) meses ou em ocasiões específicas, conforme de acordo com
      mudanças significativas no ambiente operacional ou tecnológico, ou após a
      ocorrência de incidentes de segurança.
    </p>
    <p>
      A CPGeo se compromete a cooperar plenamente com as atividades de perícia
      de prevenção e a implementar prontamente todas as recomendações
      resultantes, a fim de garantir a contínua proteção e segurança dos dados e
      ativos envolvidos.
    </p>

    <h5><b>6. ALTERAÇÕES DESTA Política de Privacidade</b></h5>

    <p>
      A atual versão da Política de Privacidade foi formulado e atualizada em 10
      de abril de 2023
    </p>

    <p>
      Reservamos o direito de modificar essa Política de Privacidade a qualquer
      tempo, principalmente em função da adequação e alterações realizadas em
      nosso site ou em função de legislações.
    </p>

    <p>
      Recomendamos que você - titular dos dados pessoais - revise com
      frequência.
    </p>

    <p>
      Eventuais alterações entrarão em vigor a partir de sua publicação em nosso
      site e sempre lhe notificaremos acerca das mudanças ocorridas.
    </p>

    <p>
      Ao utilizar nossos serviços e fornecer seus dados pessoais após tais
      modificações, você as consente.
    </p>

    <h5><b>7. DISPOSIÇÕES GERAIS</b></h5>

    <p>
      Caso tenha qualquer dúvida sobre a presente Política de Privacidade, você
      poderá encaminhar um e-mail para cpgeo@cpgeo.com.
    </p>

    <p>
      Para solução de controvérsias decorrentes do presente instrumento será
      aplicado integralmente o Direito Brasileiro.
    </p>
    <p>
      Os eventuais litígios deverão ser apresentados no foro da comarca de
      Natal/RN, local onde encontra-se a sede da empresa.
    </p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>
